import { render, staticRenderFns } from "./ModalMaterialHistory.vue?vue&type=template&id=109c97c4&"
import script from "./ModalMaterialHistory.vue?vue&type=script&lang=js&"
export * from "./ModalMaterialHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports